/* eslint-disable */
/**
 * Liest den URL-Parameter ?agency=XYZ und persistiert ihn im localStorage (Schlüssel `dmAgency`).
 * Wird bei jedem Seitenaufruf früh aufgerufen und überschreibt bestehende Werte.
 *
 * @returns {string} der gefundene Agentur-Wert (oder Leerstring)
 */
export default function captureAgency() {
    try {
        if (typeof window === 'undefined' || typeof localStorage === 'undefined') {
            return '';
        }
        const params = new URLSearchParams(window.location.search);
        const fromUrl = params.get('agency');
        if (fromUrl) {
            localStorage.setItem('dmAgency', fromUrl);
            return fromUrl;
        }
        return localStorage.getItem('dmAgency') || '';
    } catch (e) {
        return '';
    }
}

/**
 * Liest den agency-Wert aus URL oder localStorage, ohne zu schreiben.
 *
 * @returns {string}
 */
export function getAgency() {
    try {
        const params = new URLSearchParams(window.location.search);
        const fromUrl = params.get('agency');
        if (fromUrl) return fromUrl;
        if (typeof localStorage !== 'undefined') {
            return localStorage.getItem('dmAgency') || '';
        }
        return '';
    } catch (e) {
        return '';
    }
}

/**
 * Ergänzt bereits gerenderte Links zum TUI-Katalog um den agency-Parameter aus localStorage,
 * falls dort noch keiner gesetzt ist. Damit profitieren auch server-gerenderte Links
 * (z.B. aus `inc/tuiBookingUrl.php` bzw. `template-parts/blocks/CAPI-hotelGrid.php`)
 * vom persistierten Agentur-Wert nach interner Navigation.
 *
 * @param {string|string[]} [hostMatches] – Host-Teilstrings, die behandelt werden sollen.
 */
export function enrichCatalogLinksWithAgency(hostMatches = ['tui-katalog.com']) {
    try {
        const agency = getAgency();
        if (!agency) return;

        const hosts = Array.isArray(hostMatches) ? hostMatches : [hostMatches];
        const selector = hosts.map((h) => `a[href*="${h}"]`).join(', ');
        if (!selector) return;

        const links = document.querySelectorAll(selector);
        links.forEach((link) => {
            const href = link.getAttribute('href');
            if (!href) return;
            try {
                const url = new URL(href, window.location.origin);
                if (!url.searchParams.get('agency')) {
                    url.searchParams.set('agency', agency);
                    link.setAttribute('href', url.href);
                }
            } catch (e) { /* noop */ }
        });
    } catch (e) { /* noop */ }
}
